import styled from 'styled-components';
export const TabsContainer = styled.div `
  position: relative;
`;
export const ControllersGradientWrapper = styled.div `
  display: flex;
  position: relative;
`;
export const Gradient = styled.div `
  background: linear-gradient(90deg, rgba(255,255,255,0.001), white 80%);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 18px;
  width: 60px;
`;
export const TabsHeader = styled.div `
  width: 100%;
  display: flex;
  justify-content: ${props => props.centered ? `center` : `flex-start`};
  font-size: 16px;
  ${props => props.theme.mixins.mobile(`
    font-size: 14px;
  `)}
  ${props => !props.noBorder && `
    border-bottom-width: 1px;
    border-color: ${props.theme.input.borderColors.secondary};
  `}
  @media screen and (max-width: 1100px) { overflow-x: auto; }
`;
export const TabButtonWrapper = styled.div `
  padding-right: 35px;
  position: relative;
  ${props => props.theme.mixins.mobile(`
    padding-right: 20px;
    &:after {
      content: none !important;
    }
  `)}
`;
export const TabButton = styled.div `
  padding: ${props => props.narrow ? `10px 0` : `45px 0 25px 0`};
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
  font-family: ${props => props.theme.font.proimary};
  white-space: nowrap;
  ${props => props.theme.mixins.mobile(`
    padding: ${props => props.narrow ? `10px 0` : ` 30px 0 20px 0`};
  `)}
  ${props => props.disabled && `
    opacity: 0.5;
    pointer-events: none;
  `}
  ${props => props.active ? 'font-weight: bold;'
    : `
    &:hover {
      color: ${props.theme.colors.primary};
    };
  `}

  // fonts sizes
  ${props => (props.active && !props.noActiveBigFont) && `
    font-size: 1.25em;
    ${props.theme.mixins.mobile('font-size: 1em;')}
  `}

  .number {
    background: #000;
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 18px;
    text-align: center;
    line-height: 18px;
    font-size: 13px;
    margin-right: 10px;
  }
`;
export const TabContent = styled.div `
  margin-left: auto;
  margin-right: auto;
  padding-top: 45px;
  ${props => props.theme.mixins.mobile(`
    padding-top: 25px;
    max-width: 100%;
    width: 100%;
  `)}
`;
export const IconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  ${props => props.theme.mixins.mobile(`
    width: 18px; 
    height: 18px; 
    margin-right: 8px;
  `)}
`;
